/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DispatchDeliveryOrderResponseDto } from '../models/DispatchDeliveryOrderResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DispatchDeliveryOrdersService {
    /**
     * Get dispatch delivery orders
     * Retrieves a list of dispatch delivery orders for the customer
     * @returns DispatchDeliveryOrderResponseDto List of dispatch delivery orders
     * @throws ApiError
     */
    public static dispatchDeliveryOrderControllerGetOrdersByCustomer(): CancelablePromise<Array<DispatchDeliveryOrderResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dispatch-delivery-orders',
            errors: {
                401: `Unauthorized - Invalid or missing JWT token`,
            },
        });
    }
}
